module.exports = "/_next/static/images/ImageCtaWrapper-835bd723f22e3e83e92382ce382aac31.png";